import React, { FormEvent } from "react";
import BreadCrumb from "Common/BreadCrumb";
import useInputChange from "hooks/useInputChange";
import { InvoiceCreate } from "types/invoice.interface";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { BookingCard } from "Common/Components/BookingCard";
import { useMutation, useQueryClient } from "react-query";
import { createInvoice } from "services/invoice.service";
import { toast, ToastContainer } from "react-toastify";
import { Booking } from "types/booking.interface";
import { formatCurrency, nairaSymbol } from "utills/helper";
import { MyndaType } from "shared";

const SendInvoice = () => {
  const { state, onChange } = useInputChange<InvoiceCreate>({
    transportationFee: "",
    chargedFee: "",
    salary: "",
    labTest: "",
  });

  const searchParams = useSearchParams()[0];
  const queryClient = useQueryClient();
  const navigation = useNavigate();

  const bookingId = searchParams.get("booking");

  const { state: locationState } = useLocation();

  const { isLoading, mutate } = useMutation(
    async (input: InvoiceCreate) => await createInvoice(bookingId!, input),
    {
      onSuccess(data) {
        toast(data?.message || "Invoice sent");
        queryClient.invalidateQueries("bookings");
        navigation(-1);
      },
      onError(error: any) {
        toast.error(error?.response?.data?.message);
      },
    }
  );

  const booking = locationState.booking as Booking;

  // commission is 10% 0f mynda annula salary
  const annualSalary =
    booking.amount * 12 || booking?.job
      ? Number(booking.job?.maxSalary || booking.job?.salary) * 12
      : Number(booking.mynda?.salaryExpectations) * 12;

  const commision = annualSalary * (10 / 100);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    const payload: InvoiceCreate = {
      ...state,
      // @ts-expect-error no error
      chargedFee: commision || 0,
      // @ts-ignore no error
      transportationFee: state.transportationFee
        ? Number(state.transportationFee)
        : 0,
      // @ts-ignore no error
      salary: state.salary ? Number(state.salary) : 0,
    };

    mutate(payload);
  };

  return (
    <React.Fragment>
      <BreadCrumb title="Send Invoice" pageTitle="Invoice" />
      <ToastContainer />

      <div className=" my-8 px-4 w-full lg:max-w-[70%] bg-white rounded-md py-8">
        {locationState && locationState.booking && (
          <BookingCard booking={locationState?.booking} showBtn={false} />
        )}
        <div className="flex flex-col my-4">
          <p>Employer Message</p>
          <p className=" text-sm font-normal text-gray-400">
            {locationState?.booking?.message ? (
              <>{locationState?.booking?.message}</>
            ) : (
              "No message"
            )}
          </p>
        </div>

        <div className="flex flex-col my-4">
          <p>Mynda Type</p>
          <p className=" text-sm font-normal text-gray-400">
            {locationState?.booking?.bookingType || "Not specified"}
          </p>
        </div>
      </div>

      <form
        onSubmit={handleSubmit}
        className=" bg-white rounded-md p-4 flex flex-col gap-8 w-full lg:max-w-[70%] my-4"
      >
        {locationState?.booking?.bookingType?.toLowerCase() ===
          MyndaType.LeaveIn.toLowerCase() && (
          <>
            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Transaport Fee
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed"
                placeholder="transportation fee"
                name="transportationFee"
                onChange={onChange}
                value={state.transportationFee}
                required
                pattern="[0-9]+"
              />
            </div>
          </>
        )}

        <div className="mb-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Commission Fee ({nairaSymbol})
          </label>
          <input
            type="text"
            className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent disabled:bg-gray-50 disabled:text-gray-400 placeholder:text-gray-400"
            placeholder="Commission fee"
            name="chargedFee"
            onChange={onChange}
            value={formatCurrency(commision)}
            required
            pattern="[0-9]+"
            disabled
          />
        </div>

        <div className="flex justify-end gap-2 mt-4">
          <button
            type="submit"
            className="inline-flex items-center px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors"
          >
            {isLoading ? "Loading..." : "Send Voice"}
          </button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default SendInvoice;
